module.exports = __webpack_public_path__ + "img/2026-03-24c_6.f776837a.jpg";